<template>
  <div class="page">
    <div class="tab-wrap">
      <div
        class="tab"
        :class="{ active: tabIndex === 0 }"
        @click="tabIndex = 0"
      >
        借阅
      </div>
      <div
        class="tab"
        :class="{ active: tabIndex === 1 }"
        @click="tabIndex = 1"
      >
        预约
      </div>
    </div>
    <div
      class="list-wrap"
      v-show="tabIndex === 0"
    >
      <van-list>
        <div
          class="aleph-item-wrap"
          v-for="(item, index) in loanBookList"
          :key="index"
        >
          <div>
            <img
              class="cover"
              :src="`${ALEPH_BOOK_COVER_URL}${item.z13IsbnIssn}/cover`"
              alt="暂无封面"
            />
          </div>
          <div class="text-wrap">
            <div
              class="text van-multi-ellipsis--l2"
              v-if="item.z13Title"
            >
              <span class="tit">书名：</span>{{ item.z13Title }}
            </div>
            <div
              class="text van-ellipsis"
              v-if="item.z13Author"
            >
              <span class="tit">作者：</span>{{ item.z13Author }}
            </div>
            <div
              class="text van-ellipsis"
              v-if="item.z13ImPrint"
            >
              <span class="tit">出版社：</span>{{ item.z13ImPrint }}
            </div>
            <div
              class="text van-ellipsis"
              v-if="item.z30BarCode"
            >
              <span class="tit">条码：</span>{{ item.z30BarCode }}
            </div>
            <div
              class="text van-ellipsis"
              v-if="item.dueDate"
            >
              <span class="tit">应还日期：</span>{{ `${item.dueDate} ${item.dueHour}` }}
            </div>
            <div class="text">
              <van-button
                @click="handleRenew(item)"
                type="primary"
                size="small"
                class="btn"
              >续 借</van-button>
            </div>
          </div>
        </div>
        <div
          class="no-data"
          v-if="loanBookList.length<=0"
        >暂无数据</div>
      </van-list>
    </div>
    <div
      class="list-wrap"
      v-show="tabIndex === 1"
    >
      <van-list>
        <div
          class="aleph-item-wrap"
          v-for="(item, index) in holdBookList"
          :key="index"
        >
          <div>
            <img
              class="cover"
              :src="`${ALEPH_BOOK_COVER_URL}${item.z13IsbnIssn}/cover`"
              alt="暂无封面"
            />
          </div>
          <div class="text-wrap">
            <div
              class="text van-multi-ellipsis--l2"
              v-if="item.z13Title"
            >
              <span class="tit">书名：</span>{{ item.z13Title }}
            </div>
            <div
              class="text van-ellipsis"
              v-if="item.z13Author"
            >
              <span class="tit">作者：</span>{{ item.z13Author }}
            </div>
            <div
              class="text van-ellipsis"
              v-if="item.z13ImPrint"
            >
              <span class="tit">出版社：</span>{{ item.z13ImPrint }}
            </div>
            <div
              class="text van-ellipsis"
              v-if="item.z30Barcode"
            >
              <span class="tit">条码：</span>{{ item.z30Barcode }}
            </div>
            <div class="text">
              <van-button
                @click="handleCancel(item)"
                type="danger"
                size="small"
                class="btn"
              >取消预约</van-button>
            </div>
          </div>
        </div>
        <div
          class="no-data"
          v-if="holdBookList.length<=0"
        >暂无数据</div>
      </van-list>
    </div>
  </div>
</template>
<script>
import {
  alephUserInfoList,
  alephRenew,
  alephCancel,
} from "@/api/my-aleph-book";
import {
  STATUS_CODE_OK,
  TOAST_STAY_TIME,
  ALEPH_BOOK_COVER_URL,
} from "@/config";
export default {
  name: "MyAlephBook",
  data() {
    return {
      ALEPH_BOOK_COVER_URL: ALEPH_BOOK_COVER_URL,
      tabIndex: 0,
      userReaderId: "",
      loanBookList: [],
      holdBookList: [],
    };
  },
  created() {
    this.handleQuery();
  },
  methods: {
    // 列表查询
    async handleQuery() {
      const that = this;
      let { data } = await alephUserInfoList();
      if (data.code === STATUS_CODE_OK) {
        that.userReaderId = data.data.userReaderId;
        that.loanBookList = data.data.loanBookList;
        that.holdBookList = data.data.holdBookList;
      }
    },
    // 图书续借
    async handleRenew(item) {
      try {
        await this.$dialog.confirm({
          title: "提示",
          message: "确认需要续借吗",
          confirmButtonText: "续借",
          cancelButtonText: "关闭",
        });
        let { data } = await alephRenew({
          userReaderId: this.userReaderId,
          z30ItemBarCode: item.z30BarCode,
        });
        if (data.code === STATUS_CODE_OK) {
          this.$notify({
            type: "success",
            message: "续借成功",
            duration: TOAST_STAY_TIME,
          });
          this.handleQuery();
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 图书取消预约
    async handleCancel(item) {
      try {
        await this.$dialog.confirm({
          title: "提示",
          message: "确认需要取消预约吗",
          confirmButtonText: "取消预约",
          cancelButtonText: "关闭",
        });
        let { data } = await alephCancel({
          z37DocNumber: item.z37DocNumber,
          z37ItemSequence: item.z37ItemSequence,
          z37Sequence: item.z37Sequence,
        });
        if (data.code === STATUS_CODE_OK) {
          this.$notify({
            type: "success",
            message: "取消预约成功",
            duration: TOAST_STAY_TIME,
          });
          this.handleQuery();
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  background-color: #f7f8fa;
  .tab-wrap {
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
    height: 58px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 666;
    border-bottom: 1px solid #eee;
    .tab {
      color: #1282f4;
      padding: 8px 0;
      border: 1px solid #1282f4;
      width: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      &.active {
        color: #fff;
        background-color: #1282f4;
      }
    }
  }
  .list-wrap {
    position: fixed;
    left: 0;
    right: 0;
    top: 58px;
    bottom: 0;
    z-index: 666;
    overflow-y: auto;
    .aleph-item-wrap {
      display: flex;
      padding: 10px;
      background-color: #fff;
      margin-bottom: 10px;
      font-size: 12px;
      &:last-child {
        margin-bottom: 0;
      }
      .cover {
        width: 100px;
        height: 140px;
        margin-right: 10px;
        object-fit: cover;
      }
      .text-wrap {
        flex: 1;
        width: 0;
        .text {
          margin-bottom: 6px;
          color: #777;
          .tit {
            color: #000;
          }
          &:last-child {
            margin-bottom: 0;
          }
          .btn {
            padding: 6px 12px;
            height: 30px;
            border-radius: 4px;
            font-size: 12px;
          }
        }
      }
    }
    .no-data {
      padding: 10px;
      text-align: center;
      color: #999;
    }
  }
}
</style>
